import unionBy from 'lodash/unionBy';
import { IConstant } from 'types';
import { Crystal } from 'http-requests';

const normalizeMappingKey = (value?: string | null) =>
  value?.trim().toLowerCase() || '';

export const buildDefaultAddressCategories = (categories: IConstant[]) =>
  categories.map((category) => ({
    category: category.text,
    category_id: category.value,
    manual_org_ids: [],
  }));

export const mergeAddressMappings = ({
  houses,
  mappings,
  categories,
}: {
  houses: Crystal.DirectoryDTO['houses'];
  mappings: Crystal.HouseMappingDTO['mappings'];
  categories: IConstant[];
}) => {
  const mappingsMap = new Map(
    (mappings || []).map((mapping) => [
      normalizeMappingKey(mapping.house_raw),
      mapping,
    ])
  );

  return (houses || []).map((house) => {
    const matchedMapping = mappingsMap.get(normalizeMappingKey(house.address));

    return {
      directory_house_id: String(house.id),
      house_raw: house.address,
      system_address: matchedMapping?.system_address ?? null,
      system_address_id: matchedMapping?.system_address_id ?? '',
      routing_mode: matchedMapping?.routing_mode ?? 'default',
      categories: unionBy(
        matchedMapping?.categories?.length
          ? matchedMapping.categories.map((category) => ({
              category: category.category,
              category_id: category.category_id,
              manual_org_ids: category.manual_org_ids,
            }))
          : [],
        buildDefaultAddressCategories(categories),
        'category'
      ),
    };
  });
};

export const mergeSignalMappings = ({
  events,
  mappings,
}: {
  events: Crystal.DirectoryDTO['events'];
  mappings: Crystal.EventMappingDTO['mappings'];
}) => {
  const mappingsMap = new Map(
    (mappings || []).map((mapping) => [
      normalizeMappingKey(mapping.event_type),
      mapping,
    ])
  );

  return (events || []).map((event) => {
    const matchedMapping = mappingsMap.get(normalizeMappingKey(event.name));

    return {
      mapping_id: matchedMapping?.mapping_id ?? String(event.id),
      event_type: event.name,
      category: matchedMapping?.category ?? null,
      selected: false,
    };
  });
};
